import { Box } from "@mantine/core";

function MRT_TableDetailPanelWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  return (
    <Box
      mb="md"
      pl="xl"
      style={{ borderLeft: "2px solid var(--mantine-color-secondary-filled)" }}
    >
      {children}
    </Box>
  );
}

export { MRT_TableDetailPanelWrapper };
